import { instance } from '../instance';

export const querySchema = (param) => instance.post('schema/queryschema', param);
